<template>
  <v-img :src="backgroundImg" class="page-vimg with-header">
    <v-container fill-height pa-0>
      <v-layout align-center>
        <v-flex xs12>
          <v-card class="text-xs-center margin-auto border-radius6 box-white-500-glow elevation-10 auth-box">
            <v-layout align-center justify-center row fill-height wrap>
              <v-flex xs12 class="text-xs-center mt-3">
                <img src="/static/vuse-circle-white.svg" alt="Vuse" class="text-xs-center" height="100" >
                <div class="headline">Create Account</div>
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                  <v-layout wrap row pa-4>
                    <v-flex xs12 pa-0>
                      <v-text-field
                        color="purple darken-2"
                        label="Name"
                        v-model="name"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="password"
                        :rules="passwordRules"
                        label="Password"
                        type="password"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="passwordRepeated"
                        :rules="passwordRepeatedRules"
                        label="Password"
                        type="password"
                        required
                      ></v-text-field>
                      <v-checkbox color="primary" v-model="agreeToPolicy" 
                      :rules="agreeToPolicyRules" required>
                        <div slot="label">
                          <span class="grey--text">Agree to </span><span class="transparent blue--text" @click.stop="dialog = !dialog"> terms & privacy policy</span>
                        </div>
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap text-xs-center>
                        <!-- Login form submit -->
                        <v-flex xs12 class="no-mrpd">
                          <v-btn color="act" type="submit" :disabled="!valid" block @click.prevent="doRegister">Register Account</v-btn>
                        </v-flex>
                        <v-flex xs12 style="margin-top: 15px;">
                          <p><strong>Already have an account?</strong></p>
                          <v-btn :to="{ name: 'LoginPage' }" class="primary" >Sign in to your account</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Terms & privacy policy
        </v-card-title>

        <v-card-text>
          {{ this.policyText }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text  @click="dialog = false">
            Back
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" absolute top right>
      <span>{{ snackbarText }}</span>
      <!-- <v-icon dark>check_circle</v-icon> -->
    </v-snackbar>
  </v-img>
</template>

<script>
import firebase from "firebase";
export default {
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      valid: true,
      lazy: false,
      name: "",
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 50) || "Name must be less than 50 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v) || "E-mail must be valid"
      ],
      password: "",
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length > 5) || "Password must be of 6 characters minimum"
      ],
      passwordRepeated: "",
      passwordRepeatedRules: [
        v => !!v || "Password is required",
        v => (v && v.length > 5) || "Password must be of 6 characters minimum",
        v => (v && this.password === this.passwordRepeated) || "Passwords do not match"
      ],
      agreeToPolicy: false,
      agreeToPolicyRules: [
        v => !!v || 'You must agree to continue!'
      ],
      dialog: false,
      snackbar: false,
      snackBarText: '',
      snackBarColor: '',
      policyText: `
        <h5>What is privacy?</h5>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        <h5>Terms</h5>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborumLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        `,
      backgroundImg: "/static/doc-images/HexesisMaterial01.png"
    };
  },
  methods: {
    doRegister() {
      debugger;
      const self = this;
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          function(res) {
            debugger;
            self.snackbarColor = 'success';
            self.snackbarText = 'Sign up completed successfully. Please verify your email address clicking on the link in the email sent to you';
            self.snackbar = true;
            self.$refs.form.reset()
            res.user.sendEmailVerification();
            self.$router.push({ name: "LoginPage" });
          },
          function(error) {
            debugger;
            self.snackbarColor = 'error';
            self.snackbarText = error.message;
            self.snackbar = true;
            // alert("Error");
          }
        );
    },
    submit2() {
      this.snackbar = true;
      setTimeout(() => {
        this.$router.push({
          name: "HelloWorld"
        });
      }, 2000);
    },
  },
  beforeDestroy() {
    this.$refs.form.reset();
  }
};
</script>
